import { z } from "zod";
import { TierPriceUnit } from "__generated__/graphql";
import { ZodSchema } from "@validation/utils/schemaUtils";

export const TierValidationSchema = z.object({
	id: z.number().nullish(),
	minimum: ZodSchema.requiredField(z.number().int().min(0).max(10000)),
	maximum: ZodSchema.requiredField(z.number().int().min(0).max(10000)),
	priceUnit: z.enum(TierPriceUnit).nullish(),
	price: ZodSchema.requiredField(z.number().min(0)),
	pricePerMtAdditionalToLumpsum: ZodSchema.optionalNumber(0, 999999999),
});
